import { TripStatus } from "./response";

export enum TripCreationErrorKey {
  TOKEN_CONFLICT = "trip_creation_token_conflict",
}

export interface ITripRequest {
  orderIds?: number[];
  driverId?: number;
  status?: number;
  reason?: string;
}

/**
 * Creation is idempotent. Every logical POST owns one UUID and retries must
 * reuse the exact same token and payload.
 */
export interface ITripCreateRequest {
  driverId: number;
  orderIds: number[];
  createToken: string;
}

/** Structure changes are persisted before the independent start transition. */
export type ITripStructureRequest = Pick<
  ITripCreateRequest,
  "driverId" | "orderIds"
>;

/**
 * A start request can never contain driverId/orderIds. The discriminated
 * union also prevents a confirmation from being sent without its snapshot
 * token.
 */
export type ITripStartRequest =
  | {
      status: TripStatus.ACTIVE;
      startCheckConfirmed?: never;
      startCheckToken?: never;
    }
  | {
      status: TripStatus.ACTIVE;
      startCheckConfirmed: true;
      startCheckToken: string;
    };

export interface IAddOrderToTripRequest {
  orderId: number;
}

export interface IRemoveOrderFromTripRequest {
  orderId: number;
  reason: string;
}

export interface ICancelTripRequest {
  reason?: string;
}

export interface IForceChangeStatusRequest {
  status: number;
  reason: string;
}

export interface IExportTripExcel {
  trip_id: boolean;
  trip_number: boolean;
  driver_id: boolean;
  driver_classification_id: boolean;
  calculating_delivery_cost_per_kilometer: boolean;
  delivery_cost_per_kilometer: boolean;
  extra_order_fixed_bonus_amount: boolean;
  extra_order_fixed_bonus_enabled: boolean;
  order_delivery_cost: boolean;
  store_id: boolean;
  status: boolean;
  orders_count: boolean;
  total_distance: boolean;
  base_cost: boolean;
  bonus_cost: boolean;
  total_cost: boolean;
  started_at: boolean;
  completed_at: boolean;
  cancelled_at: boolean;
  cancellation_reason: boolean;
  created_at: boolean;
}

export interface IExportTripFinancialReportRequest {
  startDate: string;
  startTime?: string;
  endDate: string;
  endTime?: string;
  filters?: Array<{
    name: "driverId" | "storeId";
    value: number;
  }>;
}

export const columnsExportTripExcel = [
  "trip_id",
  "trip_number",
  "driver_id",
  "driver_classification_id",
  "calculating_delivery_cost_per_kilometer",
  "delivery_cost_per_kilometer",
  "extra_order_fixed_bonus_amount",
  "extra_order_fixed_bonus_enabled",
  "order_delivery_cost",
  "store_id",
  "status",
  "orders_count",
  "total_distance",
  "base_cost",
  "bonus_cost",
  "total_cost",
  "started_at",
  "completed_at",
  "cancelled_at",
  "cancellation_reason",
  "created_at",
];
